import React from 'react';

const FilterBlock = (props) => {
  const { currentCategory: selectedCategory, changeCategory } = props;
  
  return (
    <div className='filter-block'>
      <p className='filter-heading'>Filter by: </p>

      <div
        className={
          'All' === selectedCategory
            ? 'filter-item  filter-item-active'
            : ' filter-item'
        }
        onClick={() => changeCategory('All')}
      >
        <p>All</p>
      </div>
      
      <div
        className={
          'Cold drink' === selectedCategory
            ? 'filter-item  filter-item-active'
            : ' filter-item'
        }
        onClick={() => changeCategory('Cold drink')}
      >
        <p>Cold Drinks</p>
      </div>
      <div
        className={
          'Juice' === selectedCategory
            ? 'filter-item  filter-item-active'
            : ' filter-item'
        }
        onClick={() => changeCategory('Juice')}
      >
        <p>Juices</p>
      </div>
      <div
        className={
          'Water' === selectedCategory
            ? 'filter-item  filter-item-active'
            : ' filter-item'
        }
        onClick={() => changeCategory('Water')}
      >
        <p>Water</p>
      </div>
    </div>
  );
};

export default FilterBlock;
